export default __webpack_public_path__ + "static/media/galaxy-clean-19-nobackground.df9cb526.png";